// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K72H","option":"styles_option__3ICiA","active":"styles_active__2G94r"};